const app_base_url = process.env.REACT_APP_BASE_URL

const config = {
    GRAPHQL_URL: `https://${app_base_url}/v1/graphql`,
    GRAPHQL_WS: `wss://${app_base_url}/v1/graphql`
}
export default config